import { api } from './api';
// import axios from 'axios';

export const dashboardService = {
  // Get latest status for IO Board (PH1)
  getPumpHouseStatus: async (locationId = 'PH1') => {
    const response = await api.get(`/pumphouse/status?location=${locationId}`);
    return response.data;
  },

  getPumpHouseV2Status: async (locationId = 'PH1') => {
    const response = await api.get(`/pumphousev2/status?location=${locationId}`);
    return response.data;
  },

  // Get 6H history for a specific Water Level sensor
  getWaterLevelHistory: async (sensorId) => {
    // sensorId examples: 'PH1_WL1', 'PH1_WL2'
    const response = await api.get(`/waterlevel/history/${sensorId}`);
    return response.data;
  },

  // Get 6H history for a specific Pump sensor pump1/activeHistory?hours=6
  getPump1History: async (locationId = 'PH1', hour = 6) => {    
    const response = await api.get(`pump1/activeHistory?location=${locationId}&hours=${hour}`);
    return response.data;
  },
  getPump2History: async (locationId = 'PH1', hour = 6) => {    
    const response = await api.get(`pump2/activeHistory?location=${locationId}&hours=${hour}`);
    return response.data;
  },

  // Get 6H history for a specific Ampere sensor
  getAmpereHistory: async (sensorId) => {
    // sensorId examples: 'PH1_AMP1'
    const response = await api.get(`/ampere/history/${sensorId}`);
    return response.data;
  },

  getWeatherForecast: async () => {
    const response = await api.get('/MetMalaysia/general-forecast');
    return response.data;
  },

  getMarineForecast: async () => {
    const response = await api.get('/MetMalaysia/marine-forecast');
    return response.data;
  },

  // getWarningForecast: async () => {
  //   const response = await api.get('/MetMalaysia/warning-forecast');
  //   return response.data;
  // },

  getMetRadarGif: async () => {
    const response = await api.get('/MetMalaysia/radar.gif', {
        responseType: 'blob' 
    });
    // return response.data;
    return await response.data;
  },

  getTideHistory: async () => {
    // This is a mock implementation.
    // Replace with a real API call to get tide history data.
    // For example, using getWaterLevelHistory with a specific sensor ID for tide.
    // const response = await api.get(`/waterlevel/history/PH1_TIDE`);
    // return response.data;

    // Mock data with more points for a smoother curve and peak flags
    return Promise.resolve([
        { time: '12AM', level: 1.8, isPeak: false },
        { time: '3AM', level: 2.1, isPeak: false },
        { time: '5:46AM', level: 2.2, isPeak: true }, // High Tide
        { time: '9AM', level: 1.0, isPeak: false },
        { time: '12:40PM', level: 0.5, isPeak: true }, // Low Tide
        { time: '3PM', level: 1.1, isPeak: false },
        { time: '6:11PM', level: 1.6, isPeak: true }, // High Tide
        { time: '9PM', level: 1.2, isPeak: false },
        { time: '12AM Next', level: 1.8, isPeak: false },
    ]);
  },  
  
  getMapLocations: async () => {
    const response = await api.get(`/chirpstack/locations`);
    return response.data;
  },
};